import { AppHelper } from "../appHelper"
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { MenuEntry, Menu } from "../core/components/menu";
import { FormGenerator } from "../core/components/formGenerator";
import { Grid } from "../core/components/grid";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { TitleTextProps } from "../core/components/titleText";
import React from "react";
export class ProjectManagementTimesApp extends React.Component<ProjectManagementTimesAppProps, {
    selectedItem: ProjectManagementTimesViewModel;
}> {
    private _rightDrawerContainer: any;
    common = new AppHelper();
    translations = {};
    timesGridOptions: kendo.ui.GridOptions = null;
    menuDataSource: Array<MenuEntry> = [];


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        let metaDataAdditional = props.metadata.rightDrawerContainer;
        this._rightDrawerContainer = Helper.hasValue(metaDataAdditional) ? metaDataAdditional as any : null;
    }


    private _getNextAvailableId = () => {
        let id = 0;

        if (this.props.entity.Times && this.props.entity.Times.length > 0) {
            for (let i = 0; i < this.props.entity.Times.length; i++) {
                if (this.props.entity.Times[i].Id > id) {
                    id = this.props.entity.Times[i].Id;
                }
            }
        }

        return id + 1;
    }

    private _openEditWindow = (dataItem: ProjectManagementTimesViewModel, isNew: boolean) => {
        let firstSave = false;
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.translations["Einsatz.Stundenerfassung"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            if (isNew && dataItem.Dirty !== true && !firstSave) {
                firstSave = true;
                dataItem.Pos = 0;
                dataItem.Dirty = true;
                dataItem.Id = this._getNextAvailableId();
                this.props.entity.Times.push(dataItem);
            } else {
                for (let i = 0; i < this.props.entity.Times.length; i++) {
                    if (this.props.entity.Times[i].Id === dataItem.Id) {
                        //this.props.entity.Times[i] = dataItem;
                        this.props.entity.Times[i].Dirty = true;
                    }
                }
            }
            this._save(false);
        });
        Helper.getMetaData("projectManagementTimesEdit")
            .then(result => {
                dataItem = this._initTimeStamp(dataItem);
                sheet.show(() => {
                    sheet.mountContent(ProjectManagementTimesEditApp, {
                        entity: dataItem,
                        metadata: result,
                        context: { contextType: "projectManagementTimesEdit" },
                        isWindow: true,
                        additionalData: {
                            ressNr: this.props.entity.ResNo,
                            projNr: this.props.entity.ProjNo,
                            pIndex: this.props.entity.PIndex
                        }
                    });
                })
            });
    }

    private _initTimeStamp = (dataItem: ProjectManagementTimesViewModel) => {
        if (!Helper.hasValue(dataItem.Date)) {
            const gridData = this.props.entity.Times.sort((a, b) => {
                if (Helper.dates.toDate(a.Date) < Helper.dates.toDate(b.Date)) {
                    return -1;
                } else if (Helper.dates.toDate(a.Date) > Helper.dates.toDate(b.Date)) {
                    return 1;
                } else {
                    return 0;
                }
            });
            if (gridData.length === 0) {
                dataItem.Date = new Date();
            } else {
                let lastDate = Helper.dates.toDate(gridData[gridData.length - 1].Date);
                dataItem.Date = Helper.dates.addDays(lastDate, 1);
            }
        }
        return dataItem;
    }

    private _save = async (closeAfterSave) => {
        let result = await HTTPService.post<JsonResultClass<ProjectManagementTimesEntity>>("ProjectManagementTimes/Save", this.props.entity);
        if (result.Code === 0) {
            const times = this.props.entity.Times;
            delete this.props.entity.Times;
            Helper.updateEntity(this.props.entity, result.Data);
            this.props.entity.Times = [];

            for (let i = 0; i < result.Data.Times.length; i++) {
                const source = result.Data.Times[i];
                const target = Helper.getArrayItem(times, "Id", source.Id);
                if (target && source) {
                    $.extend(target, source);
                    target.IsNew = false;
                    this.props.entity.Times.push(target);
                }
            }
            this.setState({}, this.reloadActualHours);
            NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.handlePostSave(result.Code === 0, closeAfterSave);
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        switch (type) {
            case (ToolBarStandardButtonType.NEW):
                const item: any = Helper.createEmptyEntity();
                let newDate: Date = this.props.entity.From;
                if (Helper.hasValue(this.props.entity.Times) && this.props.entity.Times.length > 0) {
                    let timesViewModel: any = this.props.entity.Times.reduce((previous, current) => {
                        return previous.Date > current.Date ? previous : current
                    });
                    newDate = Helper.dates.addDays(timesViewModel.Date, 1);
                };
                item.Date = newDate;
                //force...
                this._openEditWindow(item as ProjectManagementTimesViewModel, true);
                break;
            case (ToolBarStandardButtonType.EDIT):
                if (dataItem.Freigabe !== false) {
                    NotificationHelper.showErrorMessage(this.translations["Einsatz.EHoursAlreadyBlockedForPM"]);
                } else {
                    const idx = Helper.findObjIndex(this.props.entity.Times, "Id", dataItem.Id);
                    const target = this.props.entity.Times[idx];

                    if (!Helper.hasValue(target.RecordRight)) {
                        target.RecordRight = {
                            CanRead: true,
                            CanWrite: true
                        };
                    }
                    this._openEditWindow(target, false);
                }
                break;
            case (ToolBarStandardButtonType.DELETE):
                if (dataItem.Freigabe !== false) {
                    NotificationHelper.showErrorMessage(this.translations["Einsatz.EHoursAlreadyBlockedForPM"]);
                } else {
                    DialogHelper.confirm(this.translations["Einsatz.TimeEntryDelete"]).then(isOK => {
                        if (isOK) {
                            const idx = Helper.findObjIndex(this.props.entity.Times, "Id", dataItem.Id);
                            const target = this.props.entity.Times[idx];
                            target.Delete = true;

                            this._save(false);
                        }
                    });
                }
                break;
        }
    }

    private _renderRightDrawerComponent = () => {
        if (Helper.hasValue(this._rightDrawerContainer)) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents}
            />
        }

        return null;
    }

    private onSelectionChanged = (dataItem: ProjectManagementTimesViewModel) => {
        this.setState({ selectedItem: dataItem }, this.reloadActualHours);
    }

    private async reloadActualHours() {
        let actualHours = 0;
        if (Helper.hasValue(this.state.selectedItem)) {
            let result = await HTTPService.get<JsonResultClass<number>>("ProjectManagementTimes/GetHoursForDay?ressNr=" + encodeURIComponent(this.props.entity.ResNo) + "&date=" + Helper.dates.getISODateString(this.state.selectedItem.Date));
            if (result.Code == 0) {
                actualHours = result.Data;
                this.setState({});
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
        MetaDataHelper.setFieldValue(this.props.entity, "entity.ActualHours", actualHours);
        this.setState({});
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({
            type: ToolBarStandardButtonType.NEW,
            caption: Config.translations.newLabel,
            enabled: this.props.entity.RecordRight.CanWrite
        });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.props.entity.RecordRight.CanWrite });
        return (
            <>
                <FullHeightContainer style={{ padding: "10px" }}>
                    <Menu enableMenuItem={this.common.evalAction} entries={this.menuDataSource} onSelect={this.common.evalAction} handleEval={this.common.evalAction} />
                    <div style={{ flexShrink: 0, overflow: "auto" }}>
                        <FormGenerator regions={this.props.metadata.tabs[0].regions} dataSources={{}} onChange={() => { }}
                            entity={this.props.entity} handleEval={this.common.evalAction} />
                    </div>
                    <div className="flex-container__item" style={{ marginTop: "15px", minHeight: "300px" }}>
                        <Grid data={this.props.entity.Times} options={this.timesGridOptions} id="projectManagementTimes"
                            standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} onSelectionChanged={this.onSelectionChanged} />
                    </div>
                </FullHeightContainer>
            </>);
    }

    render() {
        const rightDrawerComponent = this._renderRightDrawerComponent();
        const grid = this._createGrid();
        return (
            <>
                {rightDrawerComponent}
                {grid}
            </>
        );
    }
};

export class ProjectManagementTimesEditApp extends React.Component<ProjectManagementTimesEditAppProps, {
    showWarnMessage: boolean;
    warnMessage: string;
    otherTimesHours: number;
}> {
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.state = {
            showWarnMessage: false,
            warnMessage: null,
            otherTimesHours: 0
        }
    }

    componentDidMount() {
        this.getWarnMessage();
    }

    private getWarnMessage = async () => {
        var result = await HTTPService.post<JsonResultClass<number>>("ProjectManagementTimes/CheckTimeStamp", {
            model: this.props.entity,
            ressNr: this.props.additionalData.ressNr,
            projNr: this.props.additionalData.projNr,
            pIndex: this.props.additionalData.pIndex
        });
        if (result.Code == 0) {
            this.setState({ showWarnMessage: false, warnMessage: null, otherTimesHours: result.Data });
        } else if (result.Code == 1) {
            NotificationHelper.showErrorMessage(result.Message);
        } else if (result.Code == 2) {
            this.setState({ showWarnMessage: true, warnMessage: result.Message, otherTimesHours: result.Data });
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Date":
                this.getWarnMessage();
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            this.common.handlePostSave(true, true);
        }

    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const subtitleProps: TitleTextProps = { text: this.props.entity.LockMessage ? "(" + this.props.entity.LockMessage + ")" : null, style: { color: "red" } };
        let actualTimesHours = this.state.otherTimesHours;
        if (Helper.hasValue(this.props.entity.Hours))
            actualTimesHours += this.props.entity.Hours;
        const actualHoursMessage = Helper.getTranslation("Einsatz.SummeIststunden") + ": " + actualTimesHours;
        const warnMessage = this.state.showWarnMessage ? this.state.warnMessage : null;
        return (<>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <CommonApp {...props} dc3Props={subtitleProps} dc3ModuleName="app/core/components/titleText" />
                <label style={{ color: "black", margin: "10px" }}>{actualHoursMessage}</label>
                <label style={{ color: "red", margin: "10px" }}>{warnMessage}</label>
            </div>
        </>
        );
    }
}

interface ProjectManagementTimesEditAppProps extends AppBaseProps {
    entity: any;
    metadata: Metadata;
    context: {
        contextType: string;
        key1: string;
        keyVal1: any;
    };
    isWindow: boolean;
    additionalData: {
        ressNr: string;
        projNr: string;
        pIndex: number;
    }
}

export interface ProjectManagementTimesAppProps extends AppBaseProps {
    entity: ProjectManagementTimesEntity;
}

export interface ProjectManagementTimesEntity extends Entity {
    ProjNo: string;
    PIndex: number;
    ResNo: string;
    Name: string;
    From: Date;
    To: Date;
    PlannedHours: number
    Completion: number;
    ActualHours: number;
    OrderNo: number;
    Ind: number;
    Times: Array<ProjectManagementTimesViewModel>;
}

interface ProjectManagementTimesViewModel extends Entity {
    Id: number;
    Pos: number;
    Date: string | Date;
    DateOld: string | Date;
    Hours: number;
    HoursOld: number;
    Completion: number;
    Comment: string;
    Dirty: boolean;
    Delete: boolean;
    Freigabe: boolean;
}